import(/* webpackMode: "eager" */ "/home/SILANGIT-FIX/fe-silangit-app-fix/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/SILANGIT-FIX/fe-silangit-app-fix/src/components/home/header.jsx");
